import React from 'react'
import { formatDate } from '@utils/formatDate'

export interface NoticeProps {
  headline?: string
  details: string
  date?: string
  id?: string
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
function Notice({ date = null!, headline = '', details = '' }: NoticeProps) {
  const formattedDate = date ? formatDate(date) : null

  if (!headline && !formattedDate && details) {
    return (
      <section
        className="flex w-full h-full mb-4 justify-center items-center"
        data-testid="notice"
      >
        <p className="text-center">{details}</p>
      </section>
    )
  }
  return (
    <section className="flex w-full mb-4" data-testid="notice">
      <div className="hidden w-1/5 md:block" data-testid="notice-date">
        {formattedDate}
      </div>

      <div className="md:w-4/5 md:ml-1/5">
        <h2 className="flex justify-between w-full font-serif font-bold">
          {headline}
          <span className="md:hidden"> {formattedDate}</span>
        </h2>
        <p className="mt-4">{details}</p>
      </div>
    </section>
  )
}

export default Notice
